module.exports = __webpack_public_path__ + "static/media/drums.214658d2.jpg";